/*
  ============================================================
  LNV PREMIUM THEME
  Component: Why Choose LNV
  Purpose: One-time viewport reveal with Theme Editor support
  ============================================================
*/

(() => {
  const SELECTOR =
    '[data-lnv-why-choose]';

  const READY_ATTRIBUTE =
    'data-lnv-why-choose-ready';


  /*
   * Show the block immediately when motion should
   * not run or IntersectionObserver is unavailable.
   */
  function revealImmediately(root) {
    root.classList.remove(
      'lnv-why-choose--motion-ready'
    );

    root.classList.add(
      'lnv-why-choose--revealed'
    );
  }


  /*
   * Initialize one Why Choose block.
   */
  function initializeRoot(root) {
    if (
      !root ||
      root.hasAttribute(READY_ATTRIBUTE)
    ) {
      return;
    }


    root.setAttribute(
      READY_ATTRIBUTE,
      'true'
    );


    const reducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );


    if (
      reducedMotion.matches ||
      typeof IntersectionObserver ===
        'undefined'
    ) {
      revealImmediately(root);

      return;
    }


    root.classList.add(
      'lnv-why-choose--motion-ready'
    );


    const observer =
      new IntersectionObserver(
        (entries) => {
          const entry =
            entries[0];


          if (
            !entry ||
            !entry.isIntersecting
          ) {
            return;
          }


          root.classList.add(
            'lnv-why-choose--revealed'
          );


          observer.disconnect();
        },
        {
          threshold: 0.16,

          rootMargin:
            '0px 0px -10% 0px'
        }
      );


    observer.observe(root);
  }


  /*
   * Find and initialize all matching blocks
   * inside the supplied scope.
   */
  function initialize(
    scope = document
  ) {
    if (!scope) return;


    if (
      scope.matches &&
      scope.matches(SELECTOR)
    ) {
      initializeRoot(scope);
    }


    if (
      !scope.querySelectorAll
    ) {
      return;
    }


    scope
      .querySelectorAll(SELECTOR)
      .forEach(initializeRoot);
  }


  /*
   * Initial page load.
   */
  function boot() {
    initialize(document);
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }


  /*
   * Shopify Theme Editor:
   * reinitialize after dynamic section reload.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialize(
        event.target
      );
    }
  );


  /*
   * Theme Editor block selection:
   * make sure the selected block is visible.
   */
  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const selected =
        event.target &&
        event.target.closest
          ? event.target.closest(
              SELECTOR
            )
          : null;


      if (!selected) {
        return;
      }


      initializeRoot(
        selected
      );


      selected.classList.add(
        'lnv-why-choose--revealed'
      );
    }
  );
})();